let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iaA0o")).then(() => parcelRequire('9uoUd'));